import React, { useEffect } from "react";
import { makeStyles } from '@material-ui/core/styles';
import CardBox from '../components/cards/cards';

import { Button, CircularProgress, InputAdornment, TextField } from "@material-ui/core";
import { useLocation, useHistory } from "react-router-dom";


let useStyles = makeStyles(() => ({
    root: {
        width: '100%'
    },

}))




const Index = () => {

    let classes = useStyles();
    const location = useLocation();
    const navigate = useHistory();

    const { national_id } = location.state || {};

    const handelClick = () => {
        navigate('/', {
            state: {
                national_id: national_id,
            }
        }
        );
    }

    return (
        <CardBox>
            <div className={classes['root']}>
                <div className={classes['gridTilte']}>
                    <h3 className={classes['title']}>
                        ثبت نام در سجام
                    </h3>
                    <p className={classes['desc']}>
                        متاسفانه در سجام ثبت نام نکرده اید!
                    </p>
                    <p className={classes['desc']}>
                        برای ثبت نام در کارگزاری ابتدا در سجام ثبت نام نمایید.
                    </p>
                </div>
                <div className={classes['gridImages']}>
                    <img src="/assets/images/register/sejamRegister.png" alt="" />
                </div>
                <div className={classes['gridBtns']}>
                    <Button
                        className={classes.customButton}
                        variant="contained"
                        href="https://www.sejam.ir/"
                        target="_blank"
                        disabled={false}
                        style={{ color: 'white' }}
                    >
                        {false ? (
                            <>
                                در حال ارسال
                                <CircularProgress size={24} className={classes.progress} />
                            </>
                        ) : (
                            "ثبت نام در سجام"
                        )}
                    </Button>
                </div>
                <div>
                    <p className={classes['textLink']}>
                        <span onClick={() => handelClick()} style={{ cursor: 'pointer' }} >
                            کد ملی را اشتباه وارد کردید؟‌
                        </span>
                        <span onClick={() => handelClick()} style={{ cursor: 'pointer' }} >
                            اصلاح کد ملی
                        </span>
                    </p>
                </div>
            </div>
        </CardBox>
    )
}

export default Index                          